import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { useContext } from "react";
import { UserContext } from "../user";
import { useSupportHelpdeskV2Enabled } from "./use-support-helpdesk-v2-enabled";

export interface ShouldUseSupportV2State {
  readonly pending: boolean;
  readonly enabled: boolean;
}

// Redo dev users stay on legacy support-v1 even when the team has v2 enabled.
export function useShouldUseSupportV2(): ShouldUseSupportV2State {
  const { pending, enabled } = useSupportHelpdeskV2Enabled();
  const user = useContext(UserContext);
  return { pending, enabled: enabled && !isRedoEmailAddress(user?.email) };
}
